// extracted by mini-css-extract-plugin
module.exports = {"single-blog":"style_single-blog__3EV7h"};